import React, {useEffect, useState} from 'react'
import {connect} from "react-redux";

import {SlArrowLeft, SlArrowRight} from "react-icons/sl";
import c from "../etc/Const";
import FnButton from "./FnButton";

import {p1, p2} from "../plan/planitems/pl_commons";

const Dirbutton = ({lc, sendDir, width}) => {
    const _width = width - 17
    const [hover, setHover] = useState(false);
    const [dir, setDir] = useState(false);

    let lcdir = lc.dir
    if (lcdir === "1" || lcdir === "true" || lcdir === 1) {
        lcdir = true
    } else if (lcdir === "0" || lcdir === "false" || lcdir === 0) {
        lcdir = false
    }

    function setDir_() {
        setDir(!dir)
        sendDir(!dir)
    }

    useEffect(() => {
        setDir(lcdir)
    }, [lcdir]);

    let stylex = {
        width: _width+'px',
        height: p1,
        margin: '5px',
        marginTop: '0px',
        paddingTop: '1px',
        border: 'var(--border)',
        filter: hover ? 'brightness(.8)' : 'none',
        background: 'var(--inner-background)',
        display: 'flex',
        alignItems: 'center',
        verticalAlign: 'middle',
        textAlign: 'center',
        justifyContent: 'center',
    };

    return (
        <div
            onPointerOver={() => setHover(true)}
            onPointerOut={() => setHover(false)}

            style={stylex}

            onClick={setDir_}>
            {lcdir ? <SlArrowRight fontSize='large'/> : <SlArrowLeft fontSize='large'/>}
        </div>
    )
}

const mapStateToProps = state => {
    return state;
}

const mapDispatchToProps = (dispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(Dirbutton)